/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { useUI } from "../theme/ThemeProvider";
import WhatsLayout from "../layouts/WhatsLayout";

/**
 * Unified Page Container Component for admin_store
 * Provides consistent layout and styling for all pages
 */
export default function PageContainer({
  title,
  children,
  maxW = "full",
  showTitle = true,
  ...props
}) {
  const { theme, lang } = useUI();
  const isDark = theme === "dark";
  const isArabic = lang === "ar";

  return (
    <WhatsLayout title={showTitle ? title : undefined}>
      <div
        dir={isArabic ? "rtl" : "ltr"}
        className="w-full px-0 sm:px-2"
        style={{
          maxWidth: maxW === "full" ? "100%" : maxW,
          margin: "0 auto",
        }}
        {...props}
      >
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
          {children}
        </div>
      </div>
    </WhatsLayout>
  );
}

